import * as flux from 'flux';

let dispatcher = new flux.Dispatcher();

export default dispatcher;

export let safeDispatch = (payload: any) => {
    setTimeout(() => {
        dispatcher.dispatch(payload);
    }, 0);
};
